const stringToColor = string => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

export const stringAvatarProps = (name, showBgColor, sx, rest) => {
  const splitName = name.split(' ').filter(element => element);
  return {
    sx: {
      bgcolor: showBgColor ? stringToColor(name) : undefined,
      ...sx,
    },
    children:
      splitName?.length > 1
        ? `${splitName[0][0].toUpperCase()}${splitName[1][0].toUpperCase()}`
        : name?.[0].toUpperCase(),
    ...rest,
  };
};
